/* global navigator */

/**
 * Determines if the window is currently at a mobile size
 * @param {String} [maxWidth = '767px'] - max width the window can be before not being mobile
 * @returns {Boolean} whether or not the window is at a mobile screen size
 */
const isMobile = (maxWidth = "767px", detectTouch = false) => {
  const isSmallScreenSize = window.matchMedia(
    `(max-width: ${maxWidth})`,
  ).matches;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  /** @ts-ignore */
  const isTouchScreen = "ontouchstart" in window || navigator.msMaxTouchPoints;
  let mobile = isSmallScreenSize;

  if (detectTouch && isTouchScreen) {
    mobile = true;
  }

  return mobile;
};

export default isMobile;
